export default {
  "你好，请登录": "你好，请登录",
  "免费注册": "免费注册",
  "你好": "你好",
  "退出": "退出",
  "个人中心": "个人中心",
  "我的订单": "我的订单",
  "优惠券": "优惠券",
  "我的发票": "我的发票",
  "BOM需求": "BOM需求",
  "账号管理": "账号管理",
  "我的收货地址": "我的收货地址",
  "我的积分": "我的积分",
  "我的足迹": "我的足迹",
  "QQ咨询": "QQ咨询",
  "客服": "客服",
  "收藏网址": "收藏网址",
  "商户后台": "商户后台",
  "退出提示": "退出提示",
  "是否确认退出": "是否确认退出",
  "取 消": "取 消",
  "确 定": "确 定",
  "骏芯商城": "骏芯商城",
  "请输入内容": "请输入内容",
  "全部商品": "全部商品",
  "骏芯自营": "骏芯自营",
  "爆款推荐": "爆款推荐",
  "成品方案": "成品方案",
  "简体中文": "简体中文",
  "英语": "英语",
  "俄语": "俄语",
  "Hi,上午好": "Hi,上午好",
  "欢迎来到骏芯商城": "欢迎来到骏芯商城",
  "登录": "登录",
  "注册": "注册",
  "全部商品分类": "全部商品分类",
  "现货库存": "现货库存",
  "爆款推荐": "爆款推荐",
  "热": "热",
  "骏芯秒杀": "骏芯秒杀",
  "爆": "爆",
  "镜头模组": "镜头模组",
  "成品方案": "成品方案",
  "兑换专区": "兑换专区",
  "技术论坛": "技术论坛",
  "HDI板": "HDI板",
  "入驻骏芯": "入驻骏芯",
  "加入": "加入",
  "专业元器件交易商城": "专业元器件交易商城",
  "原装正品·服务优质·供应稳定": "原装正品·服务优质·供应稳定",
  "请输入需要搜索的内容": "请输入需要搜索的内容",
  "极速BOM配单": "极速BOM配单",
  "BOM文件上传": "BOM文件上传",
  "点击上传Excel文件": "点击上传Excel文件",
  "点击上传图片": "点击上传图片",
  "BOM标准模板下载": "BOM标准模板下载",
  "下载": "下载",
  "我的订单": "我的订单",
  "查看我的订单": "查看我的订单",
  "已签到": "已签到",
  "签到": "签到",
  "连续签到": "连续签到",
  "天": "天",
  "签到领积分": "签到领积分",
  "点击签到": "点击签到",
  "成交记录": "成交记录",
  "全部成交": "全部成交",
  "单": "单",
  "积分商城": "积分商城",
  "积分兑换": "积分兑换",
  "热门型号": "热门型号",
  "TOP": "TOP",
  "榜": "榜",
  "扫微信二维码咨询客服": "扫微信二维码咨询客服",
  "二维码": "二维码",
  "客户经理": "客户经理",
  "在线客服电话": "在线客服电话",
  "在线客服QQ": "在线客服QQ",
  "工作时间": "工作时间",
  "投诉电话": "投诉电话",
  "咨询客服": "咨询客服",
  "购物车": "购物车",
  "优惠劵": "优惠劵",
  "足迹": "足迹",
  "投诉": "投诉",
  "顶部": "顶部",
  "意见反馈": "意见反馈",
  "关于我们": "关于我们",
  "好":"好",
  "海量现货": "海量现货",
  "40万现货SKU": "40万现货SKU",
  "品类不断扩充": "品类不断扩充",
  "快": "快",
  "闪电发货": "闪电发货",
  "科技智能大仓储": "科技智能大仓储",
  "4小时快速交货": "4小时快速交货",
  "好": "好",
  "严控渠道": "严控渠道",
  "仅从原厂和代理商进货": "仅从原厂和代理商进货",
  "每一颗料均可原厂追溯": "每一颗料均可原厂追溯",
  "省": "省",
  "降低成本": "降低成本",
  "明码标价节省时间成本": "明码标价节省时间成本",
  "一站式采购正品元器件": "一站式采购正品元器件",
  "联系我们": "联系我们",
  "企业QQ": "企业QQ",
  "服务时间：24小时在线": "服务时间：24小时在线",
  "2011-2022 骏芯有限公司 版权所有": "2011-2022 骏芯有限公司 版权所有",


  "已取消":"已取消",
  "待支付":"待支付",
  "待付款":"待付款",
  "购物指南":"购物指南",
  "顾客必读":"顾客必读",
  "购物流程":"购物流程",
  "商品搜索":"商品搜索",
  "会员等级":"会员等级",
  "支付&配送":"支付&配送",
  "在线支付":"在线支付",
  "上门自提":"上门自提",
  "快递运输":"快递运输",
  "领券中心":"领券中心",
  "特色服务":"特色服务",
  "订货服务":"订货服务",
  "进度跟踪":"进度跟踪",
  "质量保证":"质量保证",
  "售后服务":"售后服务",
  "服务投诉":"服务投诉",
  "订单何时出库":"订单何时出库",
  "送货和验货":"送货和验货",
  "特别说明":"特别说明",
  "隐私保护政策":"隐私保护政策",
  "网站使用条款":"网站使用条款",
  "网站免责声明":"网站免责声明",
  "关于我们":"关于我们",
  "关于骏芯":"关于骏芯",
  "骏芯直播":"骏芯直播",
  "意见反馈":"意见反馈",
  // "":"",
  // "":"",

"上一张":"上一张",
"下一张":"下一张",

//addAddress.vue
"选择收货地址":"选择收货地址",
"收":"收",
"+新增收货地址":"+新增收货地址",
"收货地址":"收货地址",
"所在区域":"所在区域",
"请选择活动区域":"请选择活动区域",
"详细地址":"详细地址",
"无需重复填写省市区，小于75个字":"无需重复填写省市区，小于75个字",
"收货人姓名":"收货人姓名",
"不能为昵称、X先生、X小姐等，请使用真实姓名":"不能为昵称、X先生、X小姐等，请使用真实姓名",
"手机号":"手机号",
"手机号码、电话号码必须填一项":"手机号码、电话号码必须填一项",
"手机号":"手机号",
"保存地址":"保存地址",
"取消":"取消",
//coupon.vue  Coupons that can be used
"可使用的优惠券":"可使用的优惠券",
"没有数据":"没有数据",
"折":"折",
"免邮费":"免邮费",
"可用":"可用",
"满":"满",
"立即使用":"立即使用",
"已使用的优惠券":"已使用的优惠券",
"已使用":"已使用",
"已失效的优惠券":"已失效的优惠券",
"已失效":"已失效",
"立即使用":"立即使用",
//personal-left.vue
"个人中心":"个人中心",
"我的订单":"我的订单",
"我的优惠券":"我的优惠券",
"我的发票":"我的发票",
"账号管理":"账号管理",
"我的收货地址":"我的收货地址",
"我的积分":"我的积分",
"足迹":"足迹",
//seckill.vue
"骏芯秒杀":"骏芯秒杀",
"点场":"点场",
// "距开始":"距开始",
// "距结束":"距结束",
"最新帖子":"最新帖子",
"更多":"更多",


//views/lensMod/index.nue
"品牌":"品牌",
"分类":"分类",
//login.vue
"注册账号":"注册账号",
"输入手机号":"输入手机号",
"请输入验证码":"请输入验证码",
"获取短信验证码":"获取短信验证码",
"请输入密码":"请输入密码",
"登录/注册":"登录/注册",
"同意网站":"同意网站",
"《隐私权协议》":"《隐私权协议》",
"《骏芯平台服务协议》":"《骏芯平台服务协议》",
"和":"和",
"已有账号，去":"已有账号，去",
"登录":"登录",
"已阅读":"已阅读",

//resetpwd.vue
"忘记密码":"忘记密码",
"请输入新密码":"请输入新密码",
"记得密码，去":"记得密码，去",

//signin.vue

"密码登录":"密码登录",
"验证码登录":"验证码登录",

//goods.vue
"型号":"型号",
"品牌":"品牌",
"类目":"类目",
"批次":"批次",
"增量":"增量",
"数据手册":"数据手册",
"点击下载":"点击下载",
"暂未添加,敬请期待":"暂未添加,敬请期待",
"阶梯数":"阶梯数",
"阶梯价格":"阶梯价格",
"可替代产品":"可替代产品",
"描述":"描述",
"现货库存:":"现货库存",
"起订量":"起订量",
"近期销量":"近期销量",
"采购数量":"采购数量",
"￥":"￥",
"总价":"总价:",
"加入购物车":"加入购物车",
"立即购买":"立即购买",
"产品描述":"产品描述",
"规格":"规格",
"参数":"参数",
"PDF数据手册":"PDF数据手册",
"数据手册下载":"数据手册下载",
"上一页":"上一页",
"下一页":"下一页",
"加入购物车成功!":"加入购物车成功!",
"进入":"进入",
"购物车结算":"购物车结算",


//details.vue

"热门产品":"热门产品",
"价格":"价格",
//feedback.nue
"骏芯视频":"骏芯视频",
//list.vue
"首页":"首页",

//newsInfo.vue
"问题反馈:":"问题反馈:",
"上传图片":"上传图片",
"联系方式：":"联系方式：",
"邮箱：":"邮箱：",
"立即反馈":"立即反馈",
"下载":"下载",

//find.vue
"验证身份":"验证身份",
"修改手机":"修改手机",
"完成":"完成",
"手机验证码验证 账号":"手机验证码验证 账号",
"为确认是你本人操作，请完成以下验证":"为确认是你本人操作，请完成以下验证",
"手机验证码":"手机验证码",
"发送验证码":"发送验证码",
"确定":"确定",
"更改手机号":"更改手机号",
"绑定成功":"绑定成功",
"手机号更改成功":"手机号更改成功",


//findCode.vue
"设置新密码":"设置新密码",
"账号188******78为确认是你本人操作，请完成以下验证":"账号188******78为确认是你本人操作，请完成以下验证",
"新密码设置成功":"新密码设置成功",

//personal/index.vue

"点击编辑":"点击编辑",
"绑定手机号":"绑定手机号",
"昵称":"昵称",
"签名":"签名",
"邮箱":"邮箱",
"学历":"学历",
"公司名称":"公司名称",
"公司名称:":"公司名称:",
"请输入昵称":"请输入昵称",
"请选择":"请选择",
"请输入签名":"请输入签名",
"请输入公司名称":"请输入公司名称",
"保存提交":"保存提交",
"点击添加": "点击添加",

//integral.vue
"全部积分":"全部积分",
"签到积分":"签到积分",
"我的积分":"我的积分",
"进入兑换专区":"进入兑换专区",
"来源/用途":"来源/用途",
"积分":"积分",
"剩余积分":"剩余积分",
"时间":"时间",
"获取积分":"获取积分",
"扣除积分记录":"扣除积分记录",

//myFp.vue
"我的发票列表":"我的发票列表",
"没有数据":"没有数据",
"对应商品订单":"对应商品订单",
"查看详情":"查看详情",
"发票抬头":"发票抬头",
"开票金额(元)":"开票金额(元)",
"发票税率(%)":"发票税率(%)",
"发票内容":"发票内容",
"备注":"备注",
"审核中":"审核中",
"已出票":"已出票",
//order.vue

"默认地址":"默认地址",
"已完成":"已完成",
"所有订单":"所有订单",
"售后订单":"售后订单",
"商城":"商城",
"单价（含税）":"单价（含税）",
"数量":"数量",
"总计（元）":"总计（元）",
"订单状态":"订单状态",
"操作":"操作",
"订单号":"订单号",
"下单时间":"下单时间",
"普通商品":"普通商品",
"秒杀商品":"秒杀商品",
"爆款商品":"爆款商品",
"新品":"新品",
"成品":"成品",
"积分商品":"积分商品",
"去支付":"去支付",
"查看订单":"查看订单",
"确认收货":"确认收货",
"替代方案":"替代方案",
"再次购买":"再次购买",
"待发货":"待发货",
"待评论":"待评论",
"待收货":"待收货",
"可开票":"可开票",
"去开票":"去开票",
"已提交,点击查看":"已提交,点击查看",
"开票":"开票",
"金额":"金额",
"元":"元",
"开票主体":"开票主体",
"请输入开票主体":"请输入开票主体",
"发票类型":"发票类型",
"请选择发票类型":"请选择发票类型",
"税率":"税率",
"发票抬头":"发票抬头",
"请输入发票抬头":"请输入发票抬头",
"开票内容":"开票内容",
"请输入开票内容":"请输入开票内容",
"请输入备注":"请输入备注",
"确认开票":"确认开票",
//orderInfo.vue

"1、提交订单":"提交订单",
"2、付款成功":"付款成功",
"3、仓库发货":"仓库发货",
"4、确认收货":"确认收货",
"当前状态":"当前状态",
"立即兑换":"立即兑换",
"立即支付":"立即支付",
"删除订单":"删除订单",
"立即收货":"立即收货",
"订单详情":"订单详情",
"订单收货地址":"订单收货地址",
"物流单号":"物流单号",
"订单类型":"订单类型",
"付款积分":"付款积分",
"付款金额":"付款金额",
"是否开票":"是否开票",
"已提交":"已提交",
"订单":"订单",
"商品信息":"商品信息",
"分类/描述/参数品牌":"分类/描述/参数品牌",
"优惠":"优惠",
"小计":"小计",
"申请退款":"申请退款",
"已申请退款":"已申请退款",
"退货":"退货",
"已退款":"已退款",
"商品应付总计":"商品应付总计",
"运费":"运费",
"优惠券抵扣金额":"优惠券抵扣金额",
"应付积分":"应付积分",
"应付金额":"应付金额",
"退货信息":"退货信息",
//orderSucceed.vue
"您的订单已支付成功":"您的订单已支付成功",
"安全提醒:请不要将银行卡、密码、手机验证码提供给他人":"安全提醒:请不要将银行卡、密码、手机验证码提供给他人",
"查看我的订单":"查看我的订单",


//allProducts.vue

"功能":"功能",
"原装正品":"原装正品",
"闪电配送":"闪电配送",
"售后无忧":"售后无忧",
"商品总数":"商品总数",
"按钮":"按钮",
"供应商型号":"供应商型号",
"类别":"类别",
"厂牌":"厂牌",
"货期:内地 1工作日":"货期:内地 1工作日",
"价格梯度":"价格梯度",
"库存":"库存",
"合计":"合计",

//endProduct.vue
"成品方案":"成品方案",
"名称":"名称",
"简介":"简介",
"文档版本":"文档版本",
"发布时间":"发布时间",


"新品推荐":"新品推荐",
"即将开始":"即将开始",
"已经结束":"已经结束",
"正在秒杀":"正在秒杀",
"距离结束":"距离结束",
"已售":"已售",
"已结束":"已结束",
"未开始":"未开始",
"立即抢购":"立即抢购",

//account.vue
"收":"收",
"提交订单":"提交订单",
"返回购物车修改":"返回购物车修改",
"应付":"应付",
"优惠券抵扣金额":"优惠券抵扣金额",
"优惠券折扣":"优惠券折扣",
"商品券":"商品券",
"立即发货":"立即发货",
"货期":"货期",
"确认商品信息":"确认商品信息",


"订单提交成功，现在只差最后一步啦!":"订单提交成功，现在只差最后一步啦!",
"支付金额":"支付金额",
"积分支付":"积分支付",


"去结算":"去结算",
"总计（不含运费）":"总计（不含运费）",
"件":"件",
"已选商品":"已选商品",
"全部":"全部",
"删除选中商品":"删除选中商品",
"删除":"删除",
"图片":"图片",
"购物车内暂时没有商品，您可以":"购物车内暂时没有商品，您可以",
"去首页查找、挑选您需要的产品":"去首页查找、挑选您需要的产品",


"申请入驻":"申请入驻",
"立即申请":"立即申请",
"代理分销品牌":"代理分销品牌",
"我们的优势":"我们的优势",
"庞大的精准客户":"庞大的精准客户",
"骏芯商城目前拥有+中小微客户，且每月有近1万精准新客户注入，可解决品牌商的新品推介、样品派发和专题推广等难题，实现0成本品牌宣":"骏芯商城目前拥有+中小微客户，且每月有近1万精准新客户注入，可解决品牌商的新品推介、样品派发和专题推广等难题，实现0成本品牌宣",
"样品快速发货":"样品快速发货",
"支持1PCS发货，满足客户小批量、多样化的样品需求。减少供应商与客户沟通成本，节省双方宝贵的时间。":"支持1PCS发货，满足客户小批量、多样化的样品需求。减少供应商与客户沟通成本，节省双方宝贵的时间。",
"现金流和产业链":"现金流和产业链",
"目前日均成交8000+订单，不做账期、只做线上现金结算，保证了长期稳定雄厚的现金流。同时，扎实的集团电子全产业链资源大大增加了":"目前日均成交8000+订单，不做账期、只做线上现金结算，保证了长期稳定雄厚的现金流。同时，扎实的集团电子全产业链资源大大增加了",
"高效的智能仓储":"高效的智能仓储",
"投入超1亿元研发ERP系统，保证了高效的仓储管理、订单管理、供应链管理等业务流程，实现极速、自动化、高准确率分拣，下单4小时内":"投入超1亿元研发ERP系统，保证了高效的仓储管理、订单管理、供应链管理等业务流程，实现极速、自动化、高准确率分拣，下单4小时内",
"大数据精准推荐":"大数据精准推荐",
"拥有海量元器件销售数据和物料清单可进行大数据分析，提供精准的用户画像、市场波动、品牌热度等，做到精准营销、合理备货、迅速响应市":"拥有海量元器件销售数据和物料清单可进行大数据分析，提供精准的用户画像、市场波动、品牌热度等，做到精准营销、合理备货、迅速响应市",




"领券立减":"领券立减",
"代理分销品牌":"代理分销品牌",
"元可用":"元可用",
"还剩下":"还剩下",
"张":"张",
"立即领取":"立即领取",



"我是贸易商":"我是贸易商",
"我是工厂":"我是工厂",
"我是代理商":"我是代理商",
"我是原厂":"我是原厂",
"联系方式:":"联系方式:",
"类型:":"类型:",
"联系人:":"联系人:",



}



// WEBPACK FOOTER //
// ./src/lang/zh.js